import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
// import { Button, Input } from "antd"; // Using Ant Design Input for better UI consistency
// import Select from "react-select";
import { Delete, Info } from "react-feather";
import { useGetAllLeaveTypesQuery } from "AppQuries/leave/leave-types";
import { format } from "date-fns";
// import Input from "Components/UI/Input";
import { Input } from "antd";
const Leave = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { data: leaveTypes } = useGetAllLeaveTypesQuery({
    companyCode: watch("companyCode"),
  });
  const leaveTypeOptions = Array.isArray(leaveTypes?.data)
    ? leaveTypes?.data
        .filter((data) => data.isActive === true)
        .map((o) => ({
          id: o.code,
          label: o.leaveName,
          value: o.leaveCode,
        }))
    : [];

  const leaveDetails = watch("employeesLeaveDetails") || [];

  leaveTypeOptions.map((leaveType) => {
    const existingLeave = leaveDetails.find(
      (leave) => leave.leaveCode === leaveType.value
    );

    if (existingLeave) {
      return existingLeave;
    }

    const newLeave = {
      slNo: 0,
      companyCode: watch("companyCode"),
      employeeCode: 0,
      leaveCode: leaveType.value,
      leaveYear: Number(format(new Date(), "yyyy")),
      noOfAllotedDays: 0,
      noOfLeaveCarryForwardFromLastYear: 0,
      leaveTaken: 0,
      leaveCarryForwardtoNextYear: 0,
      amountPaidForLeaveDays: 0,
      balanceLeaveDays: 0,
      totalLeaveDays: 0,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      user: watch("createUser"),
    };
    setValue("employeesLeaveDetails", [...leaveDetails, newLeave]);
  });

  // const addLeave = () => {
  //   const newLeave = {
  //     slNo: 0,
  //     companyCode: watch("companyCode"),
  //     employeeCode: 0,
  //     leaveCode: 0,
  //     leaveYear: 2024,
  //     noOfAllotedDays: 0,
  //     noOfLeaveCarryForwardFromLastYear: 0,
  //     leaveTaken: 0,
  //     leaveCarryForwardtoNextYear: 0,
  //     amountPaidForLeaveDays: 0,
  //     balanceLeaveDays: 0,
  //     totalLeaveDays: 0,
  //     createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
  //       new Date(),
  //       "HH:mm:ss.SSS"
  //     )}Z`,
  //     modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
  //       new Date(),
  //       "HH:mm:ss.SSS"
  //     )}Z`,
  //     user: watch("createUser"),
  //   };
  //   setValue("employeesLeaveDetails", [...leaveDetails, newLeave]);
  // };

  // const removeLeave = (index) => {
  //   const updatedLeaves = leaveDetails.filter((_, i) => i !== index);
  //   setValue("employeesLeaveDetails", updatedLeaves);
  // };

  return (
    <div>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Leave Details</span>
        </h5>
      </div>

      <div className="table-responsive" style={{ minHeight: "500px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              {/* <th>-</th> */}
              <th>Leave Name</th>
              <th>No Of Allotted Days</th>
            </tr>
          </thead>
          <tbody>
            {watch("employeesLeaveDetails")?.map((data, index) => (
              <tr key={index}>
                {/* <td>
                  <Button type="danger" onClick={() => removeLeave(index)}>
                    <Trash2 />
                  </Button>
                </td> */}
                <td>
                  {
                    leaveTypeOptions.find((o) => o.value === data.leaveCode)
                      ?.label
                  }
                </td>
                <td>
                  <Controller
                    name={`employeesLeaveDetails[${index}].noOfAllotedDays`}
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        name={`employeesLeaveDetails[${index}].noOfAllotedDays`}
                        type="number"
                        className={`form-control ${
                          errors.employeesLeaveDetails?.[index]?.noOfAllotedDays
                            ? "is-invalid"
                            : ""
                        }`}
                        value={field.value || 0} // Ensure controlled input
                        onChange={(e) => {
                          const value = Number(e.target.value); // Convert to number

                          field.onChange(value); // Update form state

                          setValue(
                            `employeesLeaveDetails[${index}].balanceLeaveDays`,
                            value
                          );
                          setValue(
                            `employeesLeaveDetails[${index}].totalLeaveDays`,
                            value
                          );
                        }}
                      />
                    )}
                  />

                  {errors.employeesLeaveDetails?.[index]?.noOfAllotedDays && (
                    <div className="invalid-feedback">
                      {
                        errors.employeesLeaveDetails?.[index]?.noOfAllotedDays
                          ?.message
                      }
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
          {/* <tbody>
            {leaveDetails.map((data, index) => (
              <tr key={index}>
                <td>
                  <Button type="danger" onClick={() => removeLeave(index)}>
                    <Trash2 />
                  </Button>
                </td>
                <td>
                  <Controller
                    name={`employeesLeaveDetails[${index}].leaveCode`}
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        className={`select ${
                          errors.employeesLeaveDetails?.[index]?.leaveCode
                            ? "is-invalid"
                            : ""
                        }`}
                        options={leaveTypeOptions}
                        placeholder="Select Leave Type"
                        onChange={(e) => {
                          setValue(
                            `employeesLeaveDetails[${index}].leaveCode`,
                            parseInt(e.value)
                          );
                          trigger(`employeesLeaveDetails[${index}].leaveCode`);
                        }}
                        value={leaveTypeOptions.find(
                          (option) => option.value === field.value
                        )}
                      />
                    )}
                  />
                  {errors.employeesLeaveDetails?.[index]?.leaveCode && (
                    <div className="invalid-feedback">
                      Please select a leave
                    </div>
                  )}
                </td>
                <td>
                  <Controller
                    name={`employeesLeaveDetails[${index}].noOfAllotedDays`}
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="number"
                        {...field}
                        className={`form-control ${
                          errors.employeesLeaveDetails?.[index]?.noOfAllotedDays
                            ? "is-invalid"
                            : ""
                        }`}
                        defaultValue={data.noOfAllotedDays || 0}
                        onChange={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          setValue(
                            `employeesLeaveDetails[${index}].balanceLeaveDays`,
                            value
                          );
                          setValue(
                            `employeesLeaveDetails[${index}].totalLeaveDays`,
                            value
                          );
                        }}
                      />
                    )}
                  />
                  {errors.employeesLeaveDetails?.[index]?.noOfAllotedDays && (
                    <div className="invalid-feedback">
                      {
                        errors.employeesLeaveDetails?.[index]?.noOfAllotedDays
                          ?.message
                      }
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody> */}
        </table>
      </div>
    </div>
  );
};

export default React.memo(Leave);
